import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {newStackSx} from '@growcloud-io/dc/util/StackUtils';

export const LandingPage = ({}) => {
  return (
    <>
      <Stack direction="column" sx={newStackSx('center','center')}>

        <Box>
          <Typography
            variant="h4"
          >COMING SOON Q4 2026</Typography>
        </Box>
      </Stack>
    </>
  );
}
